import styled from 'styled-components';

export const EmptyChatContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-height: 100%;
`;

export const Container = styled.div`
  height: 100%;
  max-height: 100%;
`;
